import { render, staticRenderFns } from "./StrategyComparisonPesosAndModerate.vue?vue&type=template&id=3b88e2d2&"
import script from "./StrategyComparisonPesosAndModerate.vue?vue&type=script&lang=ts&"
export * from "./StrategyComparisonPesosAndModerate.vue?vue&type=script&lang=ts&"
import style0 from "./StrategyComparisonPesosAndModerate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDivider,VRow})
